<ng-container *transloco="let t">
  <div class="dialog-mascot">
    <div class="mascot-backdrop">
      <img alt="" src="/assets/img/mascot-question.svg" class="mascot-image" />
    </div>
  </div>
  <h2 mat-dialog-title>{{ t('COOKIE_CONSENT_TITLE') }}</h2>
  <mat-dialog-content>
    <p>{{ t('COOKIE_CONSENT_DESCRIPTION') }}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button (click)="deny()">{{ t('COOKIE_CONSENT_DENY') }}</button>
    <button mat-flat-button (click)="accept()">{{ t('COOKIE_CONSENT_ACCEPT') }}</button>
  </mat-dialog-actions>
</ng-container>
